<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <side-bar
      :background-color="sidebarBackground"
      short-title="MSacco"
      title="MSacco"
      class="side"
    >
      <template slot="links" v-if="user === 'ZwDMWejweQ3F3xut'">
        <sidebar-item :link="{name: 'Dashboard', icon: 'ni ni-tv-2 text-primary', path: '/userDashboard'}"/>
        <sidebar-item :link="{name: 'Loan Application Form', icon: 'ni ni-single-copy-04 text-orange', path: '/loanApplication'}"/>
        <sidebar-item :link="{name: 'My Loan Applications', icon: 'ni ni-money-coins text-success', path: '/loanStatus'}"/>
        <sidebar-item :link="{name: 'Approved Loans', icon: 'ni ni-paper-diploma text-yellow', path: '/approvedLoans'}"/>
        <sidebar-item :link="{name: 'User Profile', icon: 'ni ni-single-02 text-yellow', path: '/profile'}"/>
      </template>
      <template slot="links" v-else >
        <sidebar-item :link="{name: 'Dashboard', icon: 'ni ni-tv-2 text-primary', path: '/dashboard'}"/>
        <sidebar-item :link="{name: 'New Loan Applications', icon: 'ni ni-books text-red', path: '/loanApplications'}"/>
        <sidebar-item :link="{name: 'All Applications', icon: 'ni ni-atom text-blue', path: '/allApplications'}"/>
        <sidebar-item :link="{name: 'All Loans', icon: 'ni ni-paper-diploma text-yellow', path: '/allLoans'}"/>
        <sidebar-item :link="{name: 'Register Members', icon: 'ni ni-single-copy-04 text-orange', path: '/registerMember'}"/>
        <sidebar-item :link="{name: 'Saccos Statement', icon: 'ni ni-money-coins text-success', path: '/saccoStatement'}"/>
      </template>
    </side-bar>
    <div class="main-content" :data="sidebarBackground">
      <dashboard-navbar></dashboard-navbar>

      <div @click="toggleSidebar">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
        <content-footer v-if="!$route.meta.hideFooter"></content-footer>
      </div>
    </div>
  </div>
</template>
<script>
  import DashboardNavbar from './DashboardNavbar.vue';
  import ContentFooter from './ContentFooter.vue';
  import { FadeTransition } from 'vue2-transitions';

  export default {
    components: {
      DashboardNavbar,
      ContentFooter,
      FadeTransition
    },
    data() {
      return {
        user: localStorage.getItem('mbnvscz'),
        sidebarBackground: 'vue' //vue|blue|orange|green|red|primary
      };
    },
    methods: {
      toggleSidebar() {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false);
        }
      }
    }
  };
</script>
<style lang="scss">
.slide{
  margin-top:30%;
}
</style>
